import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentHashtagInfoOrNull } from '@hashtag/shared/current-hashtag-info';
import { HashtagInfo } from '@hashtag/body/hashtag-info';
import { HashtagPost } from '@hashtag/body/hashtag-post';

export const HashtagBody: FC = () => {
  const hashtagInfo = useAtomValue($CurrentHashtagInfoOrNull);

  if (hashtagInfo) {
    return (
      <>
        <HashtagInfo />
        <HashtagPost />
        <footer />
      </>
    );
  }
};
